<!-- <p>maintenance works!</p> -->
<div class="maintenance-page" *ngIf="appConfiguration && appConfiguration.maintenance">
    <div class="maintenance-container">

        <h1 class="appName" [innerHTML]="sAppName"></h1>

        <div class="maintenance-icon">
            <!-- <span>🔧</span> -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">

                <path
                    d="M14.7 6.3a4.5 4.5 0 0 0-5.8 5.8L3.6 17.4a2.1 2.1 0 0 0 3 3l5.3-5.3a4.5 4.5 0 0 0 5.8-5.8l-3 3-2.4-.6-.6-2.4 3-3z"
                    fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"
                    stroke-linejoin="round" />

            </svg>
        </div>

        <h1>Maintenance</h1>

        <p class="maintenance-message">
            {{ appConfiguration.maintenance.message }}
        </p>

        <div class="maintenance-details" [ngStyle]="{'background-color': isMaintenanceEnded() ? 'lightyellow' : 'lightsalmon'}">

            <div class="maintenance-detail" *ngIf="appConfiguration.maintenance.start">

                <span class="label">Maintenance started</span>

                <span class="value">
                    {{ appConfiguration.maintenance.start | date:'dd MMMM yyyy, HH:mm' }}
                </span>

            </div>

            <div class="maintenance-detail" *ngIf="appConfiguration.maintenance.end">

                <span class="label">Expected completion</span>

                <span class="value">
                    {{ appConfiguration.maintenance.end | date:'dd MMMM yyyy, HH:mm' }}
                </span>

            </div>

        </div>

        <div class="maintenance-navigation">
            <button mat-raised-button color="primary" (click)="recheckClick()" [disabled]="!isMaintenanceEnded()">
                Retry
            </button>
        </div>

        <p class="maintenance-footer">
            Please try again later.
        </p>

    </div>

</div>